export default __webpack_public_path__ + "static/media/vuesax-linear-teacher.47285430.svg";